/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  getArchivedWhatsapp() {
    return axios.get(`${this.url}/archived_whatsapp`);
  }

  restoreWhatsapp(inboxId) {
    return axios.post(`${this.url}/${inboxId}/restore_whatsapp`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  getManagedTemplates(inboxId, params = {}) {
    return axios.get(`${this.url}/${inboxId}/message_templates`, { params });
  }

  getManagedTemplate(inboxId, templateId) {
    return axios.get(`${this.url}/${inboxId}/message_templates/${templateId}`);
  }

  createManagedTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/message_templates`, { template });
  }

  updateManagedTemplate(inboxId, templateId, template) {
    return axios.patch(
      `${this.url}/${inboxId}/message_templates/${templateId}`,
      { template }
    );
  }

  deleteManagedTemplate(inboxId, templateId) {
    return axios.delete(
      `${this.url}/${inboxId}/message_templates/${templateId}`
    );
  }

  submitManagedTemplate(inboxId, templateId) {
    return axios.post(
      `${this.url}/${inboxId}/message_templates/${templateId}/submit`
    );
  }

  duplicateManagedTemplate(inboxId, templateId, payload = {}) {
    return axios.post(
      `${this.url}/${inboxId}/message_templates/${templateId}/duplicate`,
      payload
    );
  }

  syncManagedTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/message_templates/sync`);
  }

  getManagedTemplateAssets(inboxId) {
    return axios.get(`${this.url}/${inboxId}/message_templates/assets`);
  }

  uploadManagedTemplateMedia(inboxId, templateId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(
      `${this.url}/${inboxId}/message_templates/${templateId}/media`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  testManagedTemplate(inboxId, templateId, payload) {
    return axios.post(
      `${this.url}/${inboxId}/message_templates/${templateId}/test_send`,
      payload
    );
  }

  getBrowserWhatsappListTemplates(inboxId) {
    return axios.get(
      `${this.url}/${inboxId}/browser_whatsapp_message_templates`
    );
  }

  getBrowserWhatsappListTemplate(inboxId, templateId) {
    return axios.get(
      `${this.url}/${inboxId}/browser_whatsapp_message_templates/${templateId}`
    );
  }

  createBrowserWhatsappListTemplate(inboxId, template) {
    return axios.post(
      `${this.url}/${inboxId}/browser_whatsapp_message_templates`,
      { template }
    );
  }

  updateBrowserWhatsappListTemplate(inboxId, templateId, template) {
    return axios.patch(
      `${this.url}/${inboxId}/browser_whatsapp_message_templates/${templateId}`,
      { template }
    );
  }

  deleteBrowserWhatsappListTemplate(inboxId, templateId) {
    return axios.delete(
      `${this.url}/${inboxId}/browser_whatsapp_message_templates/${templateId}`
    );
  }

  uploadTemplateMedia(inboxId, { file, templateName, templateLanguage }) {
    const formData = new FormData();

    if (file) {
      formData.append('file', file);
    } else {
      formData.append('template_name', templateName);
      formData.append('template_language', templateLanguage);
    }

    return axios.post(`${this.url}/${inboxId}/template_media`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }
}

export default new Inboxes();
